// @ts-nocheck
import { createContext } from 'react';

export const ReportingShareReportModalContext = createContext({
  currentSharedReportExpirationDate: undefined,
  currentSharedReportId: undefined,
  currentSharedReportLink: undefined,
  currentSharedReportName: undefined,
  currentSharedReportPassword: undefined,
  defaultSharedReportPermission: undefined,
  generateLinkButtonDisabled: false,
  loading: false,
  passwordHasBeenSaved: false,
  passwordLinkEnabled: false,
  passwordNeedsUpdate: false,
  passwordValid: false,
  selectedSharedReportPermission: undefined,
  setContext: () => '',
  sharedReportPermissions: undefined,
  showErrorToast: false,
  showLinkToast: false,
  showPasswordToast: false
});
